import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import linkPreviewService from './linkPreviewService';

const initialState = {
  userLinkState: '',
  userLinkError: false,
  userLinkSuccess: false,
  userLinkLoading: false,
  userLinkErrorMsg: '',
};

export const gettingLinkPreview = createAsyncThunk('linkPreview/gettingLinkPreview', async (data, thunkAPI) => {
  try {
    return await linkPreviewService.gettingLinkPreview(data);
  } catch (error) {
    const userLinkErrorMsg =
      (error.response && error.response.data && error.response.data.userLinkErrorMsg) ||
      error.userLinkErrorMsg ||
      error.toString();
    return thunkAPI.rejectWithValue(userLinkErrorMsg);
  }
});

export const linkPreviewSlice = createSlice({
  name: 'linkPreview',
  initialState,
  reducers: {
    resetUser: (state) => {
      state.userLinkLoading = false;
      state.userLinkSuccess = false;
      state.userLinkError = false;
      state.userLinkErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(gettingLinkPreview.pending, (state) => {
        state.userLinkLoading = true;
      })
      .addCase(gettingLinkPreview.fulfilled, (state, action) => {
        state.userLinkLoading = false;
        state.userLinkSuccess = true;
        state.userLinkState = action.payload;
      })
      .addCase(gettingLinkPreview.rejected, (state, action) => {
        state.userLinkLoading = false;
        state.userLinkError = true;
        state.userLinkErrorMsg = action.payload;
      });
  },
});
export const getLinkPriewData = (state) => state.linkPreview;

export default linkPreviewSlice.reducer;
